import React, { useState, useEffect } from "react";
import { Input, Spinner } from "reactstrap";
import { useCompanies } from "../../../hooks/companies";
import SpecificEmpresaRequiredNotice from "../../../components/SpecificEmpresaRequiredNotice";
import { AUTOPILOT_COLORS } from "../../../components/autopilot/styles";
import api from "services/api";
import ParametrosPorAssunto from "./porAssunto/ParametrosPorAssunto";
import MAPA_REMETENTE from "./porAssunto/mapas/remetente";

// Parâmetros do vínculo embarcador × remetente (H1, PO1-3259). Seletor local, como
// antes; a lista vem de GET /parametros/resolve/remetentes e o contexto é o
// EmbarcadorRemetente.Id.
const labelStyle = {
  display: "block",
  marginBottom: "0.3rem",
  color: AUTOPILOT_COLORS.muted,
  fontSize: "0.72rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

export default function ParametrosRemetente() {
  const { empresaId, hasEmpresaSelection } = useCompanies();

  const [remetentes, setRemetentes] = useState([]);
  const [loadingRemetentes, setLoadingRemetentes] = useState(false);
  const [selectedRemetenteId, setSelectedRemetenteId] = useState(null);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    setRemetentes([]);
    setSelectedRemetenteId(null);
    setErro(null);
    if (!empresaId) return undefined;

    let ativo = true;
    setLoadingRemetentes(true);
    api
      .get("/parametros/resolve/remetentes", { params: { idEmbarcador: empresaId } })
      .then((res) => {
        if (ativo) setRemetentes(Array.isArray(res.data) ? res.data : []);
      })
      .catch((e) => {
        if (ativo) setErro(e.response?.data?.error || "Erro ao carregar remetentes");
      })
      .finally(() => {
        if (ativo) setLoadingRemetentes(false);
      });
    return () => {
      ativo = false;
    };
  }, [empresaId]);

  if (!hasEmpresaSelection) {
    return (
      <div className="content">
        <SpecificEmpresaRequiredNotice message="Selecione um embarcador específico para ver os parâmetros dos remetentes." />
      </div>
    );
  }

  const selecionado = remetentes.find((r) => String(r.Id) === String(selectedRemetenteId));

  const seletor = (
    <div style={{ maxWidth: 420 }}>
      <span style={labelStyle}>Remetente</span>
      {loadingRemetentes ? (
        <div style={{ minHeight: 38, display: "flex", alignItems: "center" }}>
          <Spinner size="sm" style={{ color: AUTOPILOT_COLORS.accent }} />
        </div>
      ) : (
        <Input
          type="select"
          value={selectedRemetenteId || ""}
          onChange={(e) => setSelectedRemetenteId(Number(e.target.value) || null)}
          aria-label="Remetente"
        >
          <option value="">Selecione um remetente...</option>
          {remetentes.map((r) => (
            <option key={r.Id} value={r.Id}>
              {r.label}
            </option>
          ))}
        </Input>
      )}
      {erro ? <div style={{ color: AUTOPILOT_COLORS.statusDanger, marginTop: 6, fontSize: "0.8rem" }}>{erro}</div> : null}
      {!loadingRemetentes && remetentes.length === 0 && !erro ? (
        <div style={{ color: AUTOPILOT_COLORS.muted, marginTop: 6, fontSize: "0.8rem" }}>Nenhum remetente vinculado a este embarcador.</div>
      ) : null}
    </div>
  );

  return (
    <ParametrosPorAssunto
      escopo="remetente"
      contextoId={selectedRemetenteId}
      mapa={MAPA_REMETENTE}
      titulo="Parâmetros de Remetente"
      subtitulo={
        selecionado
          ? `Regras específicas do vínculo com ${selecionado.label}.`
          : "Regras específicas de cada remetente vinculado ao embarcador."
      }
      cabecalhoExtra={seletor}
      mensagemSemContexto="Selecione um remetente para ver os parâmetros do vínculo."
    />
  );
}
